import React from 'react';

import { colors } from '@styleseat/brand';
import NotificationBanner from '../NotificationBanner';
import { TimeCalendarDeleteIcon } from '../../../ui/Icons';
import { NotificationProps } from './useAppointmentCancelledNotification';

type AppointmentCancelledNotificationClientProps = {
  onNotificationClick: () => void;
  notification: NotificationProps;
  clientName: string;
  serviceName: string;
  startTime: string;
};

const AppointmentCancelledNotificationClient:
React.FC<AppointmentCancelledNotificationClientProps> = ({
  onNotificationClick,
  notification,
  clientName,
  serviceName,
  startTime,
}) => (
  <NotificationBanner
    icon={TimeCalendarDeleteIcon}
    notification={notification}
    handleNotificationClick={onNotificationClick}
    iconColor={colors.ash}
    highlightedText={`${clientName} cancelled ${serviceName}`}
    text={`for ${startTime}`}
  />
);

export default AppointmentCancelledNotificationClient;
